import React from 'react'
import Cleave from 'cleave.js/react'

function OfferCodeField(field) {
  return (
    <Cleave
      options={{
        blocks: [4, 2, 5],
        delimiter: '-'
      }}
      value={field.value}
      name={field.name}
      onChange={e => {
        field.onChange(e)
      }}
      onBlur={e => field.onBlur(e)}
      className="form__input"
      id="personal_offer_code"
      required
    />
  )
}

export default OfferCodeField
